module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Alan Parks\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Alan Parks")]), _vm._v(" worked in the music industry for over twenty years before becoming a full-time writer. His debut novel "), _c('I', [_vm._v("Bloody January")]), _vm._v(" was one of the top crime debuts of 2018 and was shortlisted for the prestigious international crime prize the Grand Prix de Littérature Policière. "), _c('I', [_vm._v("February’s Son")]), _vm._v(", book two in the series, was a finalist for a Mystery Writers of America Edgar Award. Parks lives and works in Glasgow.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/of1cwj/tc-custom/9781609457549.jpg?1728726175860",
      "alt": "This image is the cover for the book May God Forgive, The Harry McCoy Thrillers"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("May God Forgive, The Harry McCoy Thrillers\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("FINALIST FOR THE 2022 MCILVANNEY PRIZE  Detective Harry McCoy returns in the suspenseful, atmospheric fifth instalment in Alan Park’s internationally bestselling thriller series.  Glasgow is a city in mourning. An arson attack on a hairdresser’s has left five dead. Tempers are frayed and sentiments running high.  When three youths are charged the city goes wild. A crowd gathers outside the courthouse but as the police drive the young men to prison, the van is rammed by a truck, and the men are grabbed and bundled into a car. The next day, the body of one of them is dumped in the city centre. A note has been sent to the newspaper: one down, two to go.  Detective Harry McCoy has twenty-four hours to find the kidnapped boys before they all turn up dead, and it is going to mean taking down some of Glasgow’s most powerful people to do it.  “A series that no crime fan should miss: dangerous, thrilling, but with a kind voice to cut through the darkness.”—Scotsman")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Europa Editions\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0